<template>
    <df-app no-padding title="MyCustomers">
        <template slot="aside" v-if="rows">
            <ul class="nav nav-pills nav-stacked">
                <component :is="navItem('default')"/>
            </ul>
        </template>

        <router-view :rows="rows" title="MyCustomers" icon="male-female" @reload="load" @update="update" v-if="rows"/>
    </df-app>
</template>

<script>
    import admin from '../../../mixins/admin';
    import Customer from '../../../models/Customer';

    export default {
        mixins: [admin],

        data: () => ({
            Model: Customer,

            route: 'admin-customers',
            filters: {
                default: { title: 'Alle Kunden', icon: 'male-female', filter: () => true },
            },
        }),
    };
</script>
